exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#idmessage[data-v-a0f2e018]{height:100%}.message-wraper[data-v-a0f2e018]{display:flex;flex-direction:column;height:100%}.cc-required[data-v-a0f2e018]{border:1px solid red}.cc-call-buttons button[data-v-a0f2e018]{margin-bottom:15px;height:40px}.message[data-v-a0f2e018]{height:100%}.alert-danger[data-v-a0f2e018]{font-size:24px}.cc-attention[data-v-a0f2e018]{background-color:#f9f7c0;font-size:20px}.cc-attention .glyphicon[data-v-a0f2e018]{padding:0 15px 0 10px;font-size:24px;color:#a9a9a9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-a0f2e018&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Message.vue
// module id = 214
// module chunks = 0